// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/event-modal/styles.scss
// module id = 962
// module chunks = 0